/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { BUSIEST_AREA_CELL_DEGREES, MapPosition } from './Marker.Model';

// The facilities in the area (a cell and the cells around it) that holds the most of them.
export const getBusiestAreaFacilities = <T extends MapPosition>(facilities: T[]): T[] => {
  const cellOf = ({ latitude, longitude }: MapPosition) => [
    Math.floor(latitude / BUSIEST_AREA_CELL_DEGREES),
    Math.floor(longitude / BUSIEST_AREA_CELL_DEGREES),
  ];
  const countByCell = new Map<string, number>();
  facilities.forEach((facility) => {
    const key = cellOf(facility).join(',');
    countByCell.set(key, (countByCell.get(key) ?? 0) + 1);
  });
  const isNear = (cell: number[], other: number[]) =>
    Math.abs(cell[0] - other[0]) <= 1 && Math.abs(cell[1] - other[1]) <= 1;
  let busiestCell = cellOf(facilities[0]);
  let busiestCount = 0;
  countByCell.forEach((_, key) => {
    const cell = key.split(',').map(Number);
    let count = 0;
    countByCell.forEach((otherCount, otherKey) => {
      if (isNear(cell, otherKey.split(',').map(Number))) count += otherCount;
    });
    if (count > busiestCount) {
      busiestCount = count;
      busiestCell = cell;
    }
  });
  return facilities.filter((facility) => isNear(busiestCell, cellOf(facility)));
};
